<template>
    <select ref="selectElement">
        <slot></slot>
    </select>
</template>

<script>
import { ref, watch, watchEffect, onMounted, onUnmounted, nextTick } from "vue";
import $ from "jquery";
import "select2";

export default {
    name: "Select2",
    props: {
        modelValue: {},
        disabled: Boolean,
        hidden: Boolean,
        placeholder: String,
        config: {
            type: Object,
            default: () => ({
                placeholder: "Please select a value",
                allowClear: true,
            }),
        },
    },
    setup(props, { emit }) {
        const selectElement = ref(null);
        let select2Instance = null;
        let opened = ref(false);

        const initialize = () => {
            if (select2Instance) destroy();

            nextTick(() => {
                select2Instance = $(selectElement.value)
                    .select2(props.config)
                    .on("change", () => {
                        emit("update:modelValue", $(selectElement.value).val());
                    })
                    .on("select2:open", () => {
                        opened.value = true;
                    })
                    .on("select2:close", () => {
                        opened.value = false;
                    });

                $(selectElement.value).val(props.modelValue).trigger("change");

                if (props.hidden) {
                    $(selectElement.value).next().hide();
                }
            });
        };

        const destroy = () => {
            if (select2Instance) {
                $(selectElement.value).select2("destroy");
                select2Instance = null;
            }
        };

        watchEffect(() => {
            if (select2Instance) {
                $(selectElement.value).val(props.modelValue).trigger("change");
            }
        });

        watch(() => props.config, initialize, { deep: true });

        watch(() => props.hidden, (newValue) => {
            if (newValue) {
                $(selectElement.value).next().hide();
            } else {
                initialize();
            }
        });

        onMounted(initialize);
        onUnmounted(destroy);

        return { selectElement };
    },
};
</script>
